module.exports = __webpack_public_path__ + "img/Supabase.000dd5d4.png";